
import { apiSlice } from './apiSlice';
const USERS_URL = `${process.env.REACT_APP_BACKEND_URI}/api/v1`;
// const USERS_URL = process.env.REACT_APP_BACKEND_URI;


export const growwApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getGrowwOrders: builder.query({
      query: () => ({
        url: `${USERS_URL}/growwApi/groww-orders`,
        method: 'GET',
        credentials: "include",
      }),
    }),
    getGrowwProfile: builder.query({
      query: () => ({
        url: `${USERS_URL}/growwApi/callback`,
        method: 'GET',
        credentials: "include",
      }),
    }),
    getGrowwLoginProfile: builder.query({
      query: () => ({
        url: `${USERS_URL}/growwApi/groww-profile`,
        method: 'GET',
        credentials: "include",
      }),
    }),
    saveGrowwApikeys: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/groww/save-groww-apikey`,

        method: 'POST',
        body: data,
                credentials: "include",

      }),
    }),
   GrowwOrderPnl: builder.query({
      query: (userId) => ({
        url: `${USERS_URL}/groww/growworder-pnl/${userId}`,
        method: 'GET',
        credentials: "include",
        // params: { broker },
      }),
    }),
    getGrowwHolding: builder.query({
      query: () => ({
        url: `${USERS_URL}/growwApi/groww-holdings`,
        method: 'GET',
        credentials: "include",
        // params: { broker },
      }),
    }),
        getGrowwPosition: builder.query({
      query: () => ({
        url: `${USERS_URL}/growwApi/groww-positions`,
        method: 'GET',
        credentials: "include",
        // params: { broker },
      }),
    }),
  })
})

export const {
  useGetGrowwOrdersQuery, useGetGrowwProfileQuery, useSaveGrowwApikeysMutation,
  useGetGrowwLoginProfileQuery, useGetGrowwHoldingQuery,
useGetGrowwPositionQuery ,useGrowwOrderPnlQuery} = growwApiSlice;